import {
    BOOKING_GET_ONE_FAIL,
    BOOKING_GET_ONE_SUCCESS
} from "../actions/types";

const initialState = { booking: {} }

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case BOOKING_GET_ONE_FAIL:
            return { ...state, booking: {} }
        case BOOKING_GET_ONE_SUCCESS:
            return { ...state, booking: payload.booking }
        default:
            return { ...state };
    }
}